import {
  createColDef,
  ItemGridFilterIconType,
} from "@package/ui-apollo-components";
import {
  DeleteTagDocument,
  GetTagDocument,
  GetTagGridDocument,
  GetTagListNameIdDocument,
  useGetTagGridQuery,
  type Tag,
} from "@package/ui-gql/index-data-access";
import type { ColDef } from "ag-grid-community";
import { useMemo } from "react";
import { SidebarEntryPath } from "../../../../constants/contants";
import { useAppSelector } from "../../../../store/store";
import { ItemGridWithToolbar } from "../../../ItemGrid/ItemGridWithToolbar";

export function TagGrid() {
  const variables = useAppSelector((state) => state.itemGrid.tags.variables);

  const {
    data: dataTags,
    loading: loadingTags,
    error: errorTags,
  } = useGetTagGridQuery({ variables });

  const columnDefs = useMemo<ColDef[]>(
    () => [
      createColDef<Tag>("title", "Title", 3, 200),
      createColDef<Tag>("updatedAt", "Last Updated", 1, 125),
    ],
    [],
  );

  return (
    <ItemGridWithToolbar
      propsItemGrid={{
        sidebarEntryPath: SidebarEntryPath.tags,
        columnDefs,
        data: dataTags,
        error: !!errorTags,
        loading: !dataTags && loadingTags,
        filtersSupported: true,
        filterPanels: [<ItemGridFilterIconType key="iconType" />],
      }}
      propsItemGridToolbar={{
        title: "Tag",
        sidebarEntryPath: SidebarEntryPath.tags,
        createEnabled: true,
        deleteEnabled: true,
        deleteDocument: DeleteTagDocument,
        deleteRefetchQueries: [
          GetTagDocument,
          GetTagGridDocument,
          GetTagListNameIdDocument,
        ],
        editEnabled: true,
      }}
    />
  );
}
